<template>
  <div
    class="wrapper pa-4"
  >
    <h1>画线（Drawing lines）</h1>
    <canvas
      id="c"
      class="full-bleed"
    />

    <highlightjs
      class="mt-4"
      :code="`//..
// 线 材质
const material1 = new THREE.LineBasicMaterial( { color: 0x0000ff } );
const points = [];
points.push( new THREE.Vector3( - 10, 0, 0 ) );
points.push( new THREE.Vector3( 0, 10, 0 ) );
points.push( new THREE.Vector3( 10, 0, 0 ) );
// 线 几何体
const geometry1 = new THREE.BufferGeometry().setFromPoints( points );
const line = new THREE.Line( geometry1, material1 );
scene.add(line);
//..`"
      :language="'js'"
    />
  </div>
</template>

<script type="module">
import * as THREE from 'three';

export default {
  data() {
    return {
      fov: 75, // 相机视野范围
      aspect: 2, // 画布的宽高比 在默认情况下 canvas画布是300x150像素，所以宽高比为300/150或者说2
      near: 0.1, // 相机近平面
      far: 5, // 相机远平面

      boxWidth: 1,
      boxHeight: 1,
      boxDepth: 1,
    };
  },
  mounted() {
    this.main();
  },
  methods: {
    main() {
      // canvas
      const canvas = document.querySelector('#c');
      // 渲染器 antialias代表是否开启抗锯齿
      const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      renderer.setSize( window.innerWidth, window.innerHeight - 300, false );
      const camera = new THREE.PerspectiveCamera(90,  window.innerWidth / window.innerHeight, 1, 500 );

      // 摄像机位置 xyz
      camera.position.set( 0, 0, 15 );
      camera.lookAt( 0, 0, -0.2 );

      // 创建场景
      const scene = new THREE.Scene();

      // 几何体 宽 高 深
      const geometry = new THREE.BoxGeometry(1, 1, 1);

      // 材质
      const material = new THREE.MeshPhongMaterial({
        color: '#FFDD11',
      });

      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      const cube = new THREE.Mesh(geometry, material);
      
      // 最后我们将网格添加到场景中。
      scene.add(cube);

      // 线 材质
      const material1 = new THREE.LineBasicMaterial( { color: 0x0000ff } );
      const points = [];
      points.push( new THREE.Vector3( - 10, 0, 0 ) );
      points.push( new THREE.Vector3( 0, 10, 0 ) );
      points.push( new THREE.Vector3( 10, 0, 0 ) );
      // 线 几何体
      const geometry1 = new THREE.BufferGeometry().setFromPoints( points );
      const line = new THREE.Line( geometry1, material1 );
      scene.add(line);

      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      renderer.render(scene, camera);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      scene.add(light);

      // 判断画布是否需要调整大小
      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }

      // 立方体旋转
      function render(time) {
        time *= 0.001;  // 将时间单位变为秒

        // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }
      
        cube.rotation.x = time;
        cube.rotation.y = time;
      
        renderer.render(scene, camera);
      
        requestAnimationFrame(render);
      }
      requestAnimationFrame(render);
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>